import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IncomeStreamExclusionReason } from 'src/app/models/Argyle';
import {
  DocUploadDetail,
  DocUploadPaystubEntry,
  DraftIncomeSource,
  parseDraftDetail,
  PayFrequency,
  SaveDraftIncomeSourceRequest,
  StreamDecision,
} from 'src/app/models/income-wizard-workflow';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { PanelDecision } from '../shared/stream-review-question-panel.component';

@Component({
  selector: 'app-stream-review-docupload',
  templateUrl: './stream-review-docupload.component.html',
  styleUrls: ['./stream-review-docupload.component.less'],
})
export class StreamReviewDocuploadComponent {
  @Input() screeningId!: number;
  @Input() applicantName = '';
  @Input() existingDraft: DraftIncomeSource | null = null;
  @Input() exclusionReasons: IncomeStreamExclusionReason[] = [];
  @Input() disabled = false;

  @Output() streamDecision = new EventEmitter<StreamDecision>();

  downloadBusy: Record<number, boolean> = {};

  constructor(private appData: ApplicantDataService, private fileDownload: FileDownloadService) {}

  get detail(): DocUploadDetail | null {
    return parseDraftDetail<DocUploadDetail>(this.existingDraft);
  }

  get paystubs(): DocUploadPaystubEntry[] {
    return this.detail?.paystubs ?? [];
  }

  get suggestedAmount(): number | null {
    return this.existingDraft?.suggestedAmount ?? null;
  }

  onDownloadDocument(index: number): void {
    const stub = this.paystubs[index];
    if (!stub?.documentId || this.disabled || this.downloadBusy[index]) return;
    this.downloadBusy[index] = true;
    const fileName = stub.fileName ?? 'document';
    this.appData.DownloadArgyleDoc(stub.documentId, fileName, this.existingDraft?.inviteId ?? 0, 1).subscribe({
      next: (res) => {
        this.fileDownload.HandleFileDownload(res, 'pdf', fileName);
        this.downloadBusy[index] = false;
      },
      error: () => {
        this.downloadBusy[index] = false;
      },
    });
  }

  onDecision(d: PanelDecision): void {
    const draft: SaveDraftIncomeSourceRequest = {
      draftId: this.existingDraft?.id ?? null,
      wizardStateId: 0,
      screeningId: this.screeningId,
      streamType: this.existingDraft?.streamType ?? 2,
      subType: this.existingDraft?.subType ?? 3,
      streamIdentifier: this.existingDraft?.streamIdentifier ?? '',
      employerName: this.existingDraft?.employerName ?? null,
      incomeAmount: d.action === 'include' ? d.monthlyAmount : 0,
      payFrequency: PayFrequency.Monthly,
      suggestedAmount: this.existingDraft?.suggestedAmount ?? 0,
      notes: d.notes,
      isExcluded: d.action === 'exclude',
      exclusionReasonId: d.action === 'exclude' ? d.exclusionReasonId : null,
    };
    this.streamDecision.emit({ action: d.action, draftSource: draft });
  }
}
